import FeaturedEvent from './FeaturedEvent';


export default class FeaturedEvents {
	constructor(elm) {
        this.elm = elm;

		this.events = this.elm.querySelectorAll('[data-featured-event]');

        this.featuredEvents = [];
        this.events.forEach(event => {
            this.featuredEvents.push(new FeaturedEvent(event, this));
        });

        this.currentSlide = null;
		this.initCarousel();
	}

    initCarousel() {
        this.activeIndex = 0;
        this.currentSlide = this.featuredEvents[this.activeIndex];
        this.currentSlide.show();
    }

    next() {
        this.currentSlide.hide();

        if(this.activeIndex<this.events.length-1) {
            this.activeIndex = this.activeIndex+1;
        } else {
            this.activeIndex = 0;
        }
        this.currentSlide = this.featuredEvents[this.activeIndex];

        this.featuredEvents.forEach(featuredEvent => {
            featuredEvent.updateIndex();
        })

        this.currentSlide.show();
    }

}
